import type {ReactElement} from 'react';
import {Button, Size, Type} from '@Components/button';
import {ThemeGrid} from '@Components/ai-chat-window/components/change-style-dropdown/components/theme-grid/theme-grid';
import {ChangeStyleSourceSelector} from '@Components/ai-chat-window/components/change-style-dropdown/components/change-style-source-selector/change-style-source-selector';
import type {ChangeStyleMenuContentProps} from './change-style-menu-content.types';

export function ChangeStyleMenuContent({onThemeTileClick, chainOriginalImage, currentImageHashedId, selectedSource, onSourceSelect, selectedTheme, onApply}: ChangeStyleMenuContentProps): ReactElement {
  const getSourceSelectorWithApply = (): ReactElement | null => {
    if (!chainOriginalImage) {
      return null;
    }

    return (
      <>
        <ChangeStyleSourceSelector
          originalImageHashedId={chainOriginalImage.hashedId}
          currentImageHashedId={currentImageHashedId}
          selectedSource={selectedSource}
          onSourceSelect={onSourceSelect}
        />
        <Button type={Type.PRIMARY} size={Size.SMALL} text={window.i18next.t('pmwjs_apply')} onClick={onApply} disabled={selectedTheme === null} customClasses="_full-width" />
      </>
    );
  };

  return (
    <div className="flex-v-row gap-7">
      <ThemeGrid onThemeSelect={onThemeTileClick} selectedTheme={selectedTheme} />
      {getSourceSelectorWithApply()}
    </div>
  );
}
